import { render } from "./WrongQuestionsView.vue?vue&type=template&id=44e94fda&scoped=true"
import script from "./WrongQuestionsView.vue?vue&type=script&lang=js"
export * from "./WrongQuestionsView.vue?vue&type=script&lang=js"

import "./WrongQuestionsView.vue?vue&type=style&index=0&id=44e94fda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e94fda"]])

export default __exports__